import Login from '@/views/UserLogin.vue';
import LabHub from '@/views/LabHub.vue';
import ListExercises from '@/views/ListExercises.vue';
import Exercise from '@/views/ExecuteExercise.vue';
import NotFound from '@/views/NotFound.vue';
import LogsPage from "@/views/LogsPage.vue";
import StudentTrackingPanel from "@/views/Teacher/StudentTrackingPanel.vue";
import UserManagement from "@/views/UserManagement.vue";

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { hideCsat: true }
    },
    {
        path: '/',
        name: 'LabHub',
        component: LabHub
    },
    {
        path: '/laboratorio/:lab_slug',
        name: 'ListExercises',
        component: ListExercises,
        props: true
    },
    {
        path: '/exercise',
        name: 'Exercise',
        component: Exercise
    },
    {
        path: '/logs',
        name: 'LogsPage',
        component: LogsPage
    },
    {
        path: '/student-panel',
        name: 'StudentPanel',
        component: StudentTrackingPanel
    },
    {
        path: '/user',
        name: 'UserManagement',
        component: UserManagement
    },
    {
        path: '/csat-dashboard',
        name: 'CsatDashboard',
        component: () => import('@/views/CsatDashboard.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: "NotFound",
        component: NotFound
    }
]

export default routes;